import { Shape } from './shape'
import { buildEmptyShapeSizeConstraint, ShapeSizeConstraint } from './shape-size-constraint'
import { ShapePackagingStrategy } from './shape-packaging-strategy'

export interface ShapePackaging {
  readonly unitShape: Shape

  readonly bundleShape: Shape
  readonly bundleFillFactor: number
  readonly bundleSizeConstraints: ShapeSizeConstraint

  readonly packageShape: Shape
  readonly packageFillFactor: number
  readonly packageSizeConstraints: ShapeSizeConstraint

  readonly strategy: ShapePackagingStrategy
}

export const buildEmptyShapePackaging: () => ShapePackaging = () => ({
  unitShape: Shape.BOX,
  bundleShape: Shape.BOX,
  bundleFillFactor: 1,
  bundleSizeConstraints: buildEmptyShapeSizeConstraint(),

  packageShape: Shape.BOX,
  packageFillFactor: 1,
  packageSizeConstraints: buildEmptyShapeSizeConstraint(),

  strategy: ShapePackagingStrategy.AREA,
})
